<script setup>
import { props as formGroupProps, useFormGroup } from '@phoenix/composables/components/form/formGroup';

const props = defineProps({
  ...formGroupProps,
  labelBold: {
    type: Boolean,
    default: false,
  },
});

const {
  _shouldDisplayCharLeft,
  charLeftClasses,
  charactersLeft,
  displayedErrors,
  errorId,
  field,
  fieldUniqueId,
  helpId,
  isHidden,
  isInvalid,
  labelId,
} = useFormGroup(props);
</script>

<template>
  <div :key="`form-group-${fieldUniqueId}`" class="form-field">
    <label
      v-if="field.label && !isHidden && showLabel"
      :id="labelId"
      :for="fieldUniqueId"
      class="field-label"
      :class="{ 'field-label--error': isInvalid, 'field-label--bold': labelBold }"
    >
      {{ field.label }}
      <abbr v-if="field.required" :title="$t('Form.required')" data-cy="form-input-required">*</abbr>
    </label>

    <slot />

    <div v-if="field.help" :id="helpId" class="field-help rich-text" v-html="field.help" />
    <slot v-else name="help" />

    <div v-if="_shouldDisplayCharLeft" :class="charLeftClasses">
      {{ $t('Form.charactersLeft', { charactersLeft }) }}
    </div>

    <div v-if="isInvalid" :id="errorId" class="field-error">
      {{ displayedErrors }}
    </div>
  </div>
</template>
